import React, { useState, useEffect } from "react";
import Api from "../../services/Api";
import Config from "../../config/Config";
import logo from "../../assets/images/logo.png";

import {
  FaUserAlt,
  FaPowerOff,
  FaShoppingBag,
  FaCog,
  FaPlus,
  FaSearch,
  FaTrash,
  FaUsers,
  FaBox,
  FaShoppingCart,
} from "react-icons/fa";
import { Link } from "react-router-dom";

function Topmenu(props) {
  const logout = () => {
    localStorage.removeItem("auth_user");
    localStorage.removeItem("token");

    window.location.href = "/adminqu";
  };

  useEffect(() => {
    document.title = "Kataloqu Admin";
  }, []);

  return (
    <div className="fixed w-full ml-0 mt-0 md:p-4 shadow bg-pink-500">
      <div className="flex flex-col w-full sm:flex-row gap-4 items-center hidden md:inline-flex">
        <div className="flex-initial w-full sm:w-1/4 text-lg font-bold text-white text-left">
          <div className="text-left flex justify-center gap-1 items-center tex-md">
            <img src={logo} className="w-8" alt="logo" />
            Kataloqu Admin <span className="text-xs">v1.0.0</span>
          </div>
        </div>
        <div className="w-full sm:w-1/4 ml-auto"></div>
        <div className="flex-initial flex flex-row gap-2 w-full sm:w-1/2 text-center text-sm justify-end px-3">
          <Link to="/adminqu/catalog">
            <button className="bg-pink-700 flex flex-row items-center hover:bg-pink-600 text-white font-bold py-2 px-4 rounded-lg">
              <FaBox />
              <span className="ml-2">Katalog</span>
            </button>
          </Link>
          <Link to="/adminqu/link-reseller">
            <button className="bg-pink-700 flex flex-row items-center hover:bg-pink-600 text-white font-bold py-2 px-4 rounded-lg">
              <FaUsers />
              <span className="ml-2">Link Reseller</span>
            </button>
          </Link>

          <Link to="/adminqu/account">
            <button className="bg-pink-700 flex flex-row items-center hover:bg-pink-600 text-white font-bold py-2 px-4 rounded-lg">
              <FaUserAlt />

              <span className="ml-2">{props.authUser.first_name}</span>
            </button>
          </Link>

          <Link to="/adminqu/setting">
            <button className="bg-purple-600 flex flex-row items-center hover:bg-pink-700 text-white font-bold py-3 px-4 rounded-lg">
              <FaCog />
            </button>
          </Link>
          <button
            className="bg-red-600 flex flex-row items-center hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg"
            onClick={() => {
              localStorage.removeItem("auth_user");
              localStorage.removeItem("token");
              window.location.href = "/adminqu";
            }}>
            <FaPowerOff />
          </button>
        </div>
      </div>

      <div className="flex flex-row w-full md:flex-row gap-4 items-center md:hidden">
        <div className="w-1/3 pl-4">
          <div className="text-left flex flex-row gap-4 justify-center gap-1 items-center text-xs text-white">
            <FaShoppingBag className="text-lg text-white" />
            <span>Kataloqu Admin</span>
          </div>
        </div>
        <div className="w-2/3 flex flex-row justify-end">
          <Link to="/adminqu/catalog">
            <button className="bg-pink-700 text-white w-12 h-12 p-4 border-r border-r-pink-300">
              <FaShoppingCart />
            </button>
          </Link>
          <Link to="/adminqu/catalog">
            <button className="bg-pink-700 text-white w-12 h-12 p-4 border-r border-r-pink-300">
              <FaBox />
            </button>
          </Link>
          <Link to="/adminqu/link-reseller">
            <button className="bg-pink-700 text-white w-12 h-12 p-4 border-r border-r-pink-300">
              <FaUsers />
            </button>
          </Link>

          <Link to="/adminqu/account">
            <button className="bg-pink-700 text-white w-12 h-12 p-4 border-r border-r-pink-300">
              <FaUserAlt />
            </button>
          </Link>

          <Link to="/adminqu/setting">
            <button className="bg-purple-600 text-white w-12 h-12 p-4 border-r border-r-pink-300">
              <FaCog />
            </button>
          </Link>
          <button
            className="bg-red-600 text-white w-12 h-12 p-4"
            onClick={() => {
              localStorage.removeItem("auth_user");
              localStorage.removeItem("token");
              window.location.href = "/adminqu";
            }}>
            <FaPowerOff />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Topmenu;
